var React = require('react');

function IconPlusBase (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":".Plus Base"},React.createElement("path",{"id":"Path","d":"M12 22V2M22 12H2","stroke":"#142B6F","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"})));
}

IconPlusBase.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconPlusBase;

IconPlusBase.default = IconPlusBase;
